
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-rewriter?id=data-v-4a8d13f2!../node_modules/vue-loader/lib/selector?type=styles&index=0!./ExamplesDocsApp.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./ExamplesDocsApp.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-4a8d13f2!../node_modules/vue-loader/lib/selector?type=template&index=0!./ExamplesDocsApp.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./docs/ExamplesDocsApp.vue
// module id = 48
// module chunks = 3